import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { News, OnClickAction } from 'src/data/mygolf.data';
import * as moment from 'moment';
import { ImageZoomPage } from '../../modal-screens/image-zoom/image-zoom.page';
import { ensureHttpPrefix } from 'src/providers/common-service';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { Router } from '@angular/router';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss'],
})
export class NewsDetailsComponent implements OnInit {

  options: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no',
    closebuttoncaption: 'Close',
    disallowoverscroll: 'no',
    toolbar: 'yes',
    enableViewportScale: 'no',
    allowInlineMediaPlayback: 'no',
    presentationstyle: 'pagesheet',
    fullscreen: 'yes',
  };
  @Input() news: News;
  slideOpts: any;
  constructor(
    private modalCtrl: ModalController,
    private mg2uUtil: mygolfUtils,
    private router: Router,
    private platform: Platform,
    private iab: InAppBrowser
  ) { 
    
    this.slideOpts = {
      initialSlide: 0,
      slidesPerView: !this.isMobileLayout() ? 2.4 : this.isMobileLayout() ? 1.1 : 4,
      speed: 400,
      spaceBetween: 15,
      responsiveClass: true,
      // scrollbar:{
      //   el:'.swiper-scrollbar',
      //   draggable:true,
      // },
      autoplay: {
        delay: 1500,
        disableOnInteraction: false
      }
    };

  }

  ngOnInit() {}

  backRouting() {
    this.modalCtrl.dismiss();
  }

  getNewsImage(imageUrl: string) {
    // console.debug("get news image", imageUrl);
    return imageUrl;
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  getNewsOwnerDetails(attribute: string) {
    if(!this.news) return;
    switch(attribute) {
      case 'name':
        if(this.news?.club) return this.news?.club?.name;
        else if(this.news?.partner) return this.news?.partner?.name;
        else return '';
      case 'country':
        if(this.news?.club) return this.news?.club?.countryName;
        else if(this.news?.partner) return this.news?.partner?.country?.name;
        else return '';
    }
  }

  getNewsDetails(attribute: string) {
    if(!this.news) return;
    switch(attribute) {
      case 'date':
        if(!this.news?.startDate) return '-';
        return moment(this.news?.startDate,"YYYY-MM-DD").format('dddd, DD MMM YYYY');
      case 'time':
        if(!this.news?.startTime) return '-';
        return moment(this.news?.startTime,"HH:mm:ss").format('hh:mm a')
    }
  }

  getNewsOwnerImage() {
    // console.debug("get news owner image", this.news);
    if(!this.news) return '/assets/image/default_club.png';
    if(this.news?.club) {
      if(this.news?.club?.clubLogo) return this.news?.club?.clubLogo;
      else if(this.news?.club?.clubImage) return this.news?.club?.clubImage;
      else if(this.news?.club?.clubThumbnail) return this.news?.club?.clubThumbnail;
    } else if(this.news?.partner) {
      if(this.news?.partner?.partnerImage) return this.news?.partner?.partnerImage;
      else return '/assets/image/default_club.png';
    } else return '/assets/image/default_club.png';
  }

  async onZoomImage(image: string) {
    
    const modal: any = await this.modalCtrl.create(
      {
        component: ImageZoomPage,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          image: image,
          // description: _description,
          // descTopDown: 'top'
        }
      });
    await modal.present();
  }
  
  hasNewsOwner() {
    if(!this.news) return;
    if(this.news?.club) return true;
    else if(this.news?.partner) return true;
    else return;
  }


  hasViewMore() {
    // console.debug("has view more ", this.news);
    if(!this.news) return;
    if(this.news.onClick) {
      if(this.news?.onClick?.actionType === 'None') return false;
      else return true;
    }
    else return false;
  }
  
  onClickMore() {
    // console.debug("on click promo ads ", this.news)
    let _onClickAction: OnClickAction = this.news?.onClick;
    let _actionValue = '';
    if(_onClickAction?.actionValue) _actionValue = _onClickAction.actionValue;
    if(_onClickAction?.actionType) {
      switch(_onClickAction.actionType) {
        case 'None':
          break;
        case 'OpenUrl':
          let _url = ensureHttpPrefix(_actionValue);
          if(this.platform.is('capacitor')) {
            this.openWithInAppBrowser(_url);
          } else {
            let win = window.open(_url, '_system');
          }
          break;
        case 'OpenPage':
          this.modalCtrl.dismiss().then(()=>{
            this.router.navigate([_actionValue]);
          })
          break;
        default:
      }
    }
  }

  
  public openWithInAppBrowser(
    url: string,
    target?: string,
  ) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.options);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe((event) => {
        let loc = event.url.toLowerCase();
      });
    } else {
      _iab.on('loadstop').subscribe((event) => {
        let loc = event.url.toLowerCase();
      });
    }
    _iab.on('exit').subscribe(
      () => {
      },
      (err) => {},
    );
  }
}
